var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.499,
    height: 39.531,
    viewBox: "0 0 39.499 39.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(-2.75 -2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10549",
    "data-name": "Path 10549",
    d: "M34.631,31.556l.731,5.925a1.866,1.866,0,0,1-2.812,1.837L24.693,34.65a18.717,18.717,0,0,1-2.531-.169,9.114,9.114,0,0,0,2.213-5.925c0-5.325-4.613-9.637-10.313-9.637a10.656,10.656,0,0,0-5.85,1.706A11.886,11.886,0,0,1,8.137,19.2c0-8.531,7.406-15.45,16.556-15.45S41.249,10.669,41.249,19.2A15.1,15.1,0,0,1,34.631,31.556Z",
    fill: "none",
    stroke: "#fd792f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M24.375,28.556a9.114,9.114,0,0,1-2.212,5.925,10.47,10.47,0,0,1-8.1,3.694L9.169,41.081a1.173,1.173,0,0,1-1.763-1.144l.469-3.694a9.253,9.253,0,0,1,.338-15.619,10.656,10.656,0,0,1,5.85-1.706C19.763,18.919,24.375,23.231,24.375,28.556Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.7a4e704211d0c9701b1d0bbf1d986e29.svg";
export { ForwardRef as ReactComponent };